import React from "react";
import styles from "./styles.module.scss";
import {
  DownArrow,
  MovementIcon,
  UpArrow,
} from "../../Styles/Icons/DesignSystem";
import theme from "../../Styles/theme.scss";

const InsightMovementComparison = ({
  noChange,
  isIncrease,
  isDecrease,
  cannotCalculate,
  amountChange,
  dateType,
  insightContext,
  insightCompareValues,
  daysWithNoData,
}) => {
  const daysWithNoDataText = !daysWithNoData
    ? null
    : `${daysWithNoData} day${daysWithNoData === 1 ? "" : "s"} with no data`;

  return (
    <div className={styles.insight}>
      <div className={styles.insight_top}>
        <MovementIcon size={22} />
        Compared to
        <span style={{ width: "8px" }} />
        <span className={styles.underline}>{` last ${dateType}`}</span>
      </div>
      <div className={styles.insight_data}>
        {!noChange && isIncrease && (
          <UpArrow color={theme.neutral7} percentChange={3} />
        )}
        {!noChange && isDecrease && (
          <DownArrow color={theme.neutral7} percentChange={3} />
        )}
        <div
          className={
            noChange || cannotCalculate
              ? styles.insight_no_change
              : styles.insight_amount_change
          }
        >
          {cannotCalculate ? "Not enough data" : amountChange}
        </div>
      </div>
      <p>
        {insightContext}{" "}
        {!cannotCalculate && (
          <span className={styles.underline}>{insightCompareValues}</span>
        )}
      </p>
      {!!daysWithNoData && (
        <p>
          There {daysWithNoData === 1 ? "was" : "were"}:{" "}
          <span className={styles.underline}>{daysWithNoDataText}</span>
        </p>
      )}
    </div>
  );
};

export default InsightMovementComparison;
